// Dependencies
import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
// Hooks
import useSettings from "../hooks/useSettings"

const IS_PRODUCTION = process.env.NODE_ENV === "production"

function useFavicon() {
  const [number, set] = useState(1)

  let timer
  useEffect(() => {
    const changeIcon = () => {
      set(prev => {
        return prev === 9 ? 1 : prev + 1
      })
    }
    timer = setInterval(changeIcon, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [])

  return `/favicon_0${number}.png`
}

function Meta({
  title = "",
  description = "",
  shareImage = "",
  lang = "en",
  meta = [],
}) {
  const settings = useSettings()

  const metaTitle = title
    ? `${title} | ${settings.defaultMetaTitle}`
    : settings.defaultMetaTitle
  const metaDescription = description || settings.defaultMetaDescription
  // const metaImage = shareImage && shareImage.fluid.src || settings.defaultShareImage.fluid.src;
  const metaImage = shareImage?.file?.url
    ? `${shareImage?.file?.url}?w=1920&q=50`
    : settings?.defaultShareImage?.fluid?.src
    ? `${settings.defaultShareImage.fluid.src}?w=1920&q=50`
    : ""

  const favicon = useFavicon()

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: "og:image",
          content: `https:${metaImage}`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: `@paulsmithsfoundation`,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          property: "twitter:image",
          content: `https:${metaImage}`,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    >
      <link rel="icon" href={favicon} />
      {IS_PRODUCTION && (
        <script
          type="text/javascript"
          src={`//static.klaviyo.com/onsite/js/klaviyo.js?company_id=${process.env.GATSBY_KLAVIYO_ID}`}
          async
        />
      )}
    </Helmet>
  )
}

Meta.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  shareImage: PropTypes.object,
}

export default Meta
